import React from 'react'

export default function Mainlogo_banner({ref}) {
   
  return (
   
    <>
    <div  className='logodesign-p' ref={ref}>
        <section class="bannermm" id="logo_design_top">
         <div class="container">
            <div class="row">
               <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="leftcont-ban">
                     <h1 class="montfont">
                        <span>Creating </span>
                        <br/>
                        <strong>Exclusive Designs</strong> to Enhance Your Brand
                     </h1>
                     <p>Stand apart through our brilliant logo designs. </p>
                     <a class="montfont poundbtn logobtnsstart popup-open" href="javascript:;" title="">Start Your Logo Project from $59
                     <i class="sprite btnarow"></i>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </section>
    </div>
    </>
  )
}  